import Vue from 'vue'
import $ from 'jquery'
import _ from 'lodash'
import KNextZIndex from '../../utils/KNextZIndex'
import KNextBelowZIndex from '../../utils/KNextBelowZIndex'
import PopperEngine from 'popper.js'
import { sub, unSub, CLICK_OUTSIDE } from '../../utils/KGevent'
import KUuid from '../../utils/KUuid'
import { convertPropClass2ClassObjectLike } from '../../utils/KProps'
import { getAllDescendantComponentsByName, getParentByName, isVueComponent } from '../../utils/KVdom'
import { window } from 'ssr-window'

// import { getCorrectEventName } from '../animation'
// const transitionEnd = getCorrectEventName(window, 'transitionend')

export const PopperType = {
  TOOLTIP: 0,
  POPOVER: 1,
}

const TooltipOptions = {
  placement: 'top',
  // modifiers: {
  //   preventOverflow: {
  //     boundariesElement: 'window',
  //   },
  // },
}

const PopoverOptions = {
  placement: 'top',
  // modifiers: {
  //   preventOverflow: {
  //     boundariesElement: 'window',
  //   },
  // },
}

const getMetaOptions = (popperType) => {
  switch (popperType) {
    case PopperType.TOOLTIP:
      return TooltipOptions
    case PopperType.POPOVER:
      return PopoverOptions
    default:
      return {}
  }
}

const arrowSize = 12
// const arrowMargin = arrowSize / 2
export const positions = {
  top: {
    origin: () => 'center bottom',
  },
  'top-start': {
    origin: ({ arrowStyles }) => `${arrowStyles.left - arrowSize}px bottom`,
  },
  'top-end': {
    origin: ({ arrowStyles }) => `${arrowStyles.left + arrowSize}px bottom`,
  },
  right: {
    origin: () => 'left center',
  },
  'right-start': {
    origin: ({ arrowStyles }) => `left ${arrowStyles.top - arrowSize}px`,
  },
  'right-end': {
    origin: ({ arrowStyles }) => `left ${arrowStyles.top + arrowSize}px`,
  },
  bottom: {
    origin: () => 'center top',
  },
  'bottom-start': {
    origin: ({ arrowStyles }) => `${arrowStyles.left - arrowSize}px top`,
  },
  'bottom-end': {
    origin: ({ arrowStyles }) => `${arrowStyles.left + arrowSize}px top`,
  },
  left: {
    origin: () => 'right center',
  },
  'left-start': {
    origin: ({ arrowStyles }) => `right ${arrowStyles.top - arrowSize}px`,
  },
  'left-end': {
    origin: ({ arrowStyles }) => `right ${arrowStyles.top + arrowSize}px`,
  },
}
// let onClickOutsideRegistered = false
// let clickTarget = null
// let triggerPopper = null

export default {
  inheritAttrs: false,
  props: {
    value: {
      // v-model 显示或者隐藏
      type: Boolean,
      default: false,
    },
    // popperClass: {
    //   // 自定义 popper 类，将作用于 popper 上面
    //   type: String,
    //   default: '',
    // },
    popperClass: {
      // 自定义 popper 类，将作用于 popper 上面
      validator: (value) => _.isString(value) || _.isArray(value) || _.isObjectLike(value),
      default() {
        return {}
      },
    },
    content: {
      // 当且仅当内容区为文本内容时，使用 content 方便传值，否则建议使用内容分发`slot`定义弹出区域的内容
      validator() {
        return true
      },
      default: '',
    },
    trigger: {
      // 触发 popper 弹出的方式
      type: String,
      default: 'hover',
      validator: (value) => ['click', 'focus', 'hover', 'manual'].indexOf(value) !== -1,
    },
    placement: {
      // popper 默认弹出的位置，值请参考 positions 的属性
      type: String,
      default: undefined,
    },
    // 10
    // '10%'
    // '10, 10'
    // '10%, 10'
    // '10 + 10%'
    // '10 - 5vh + 3%'
    // '-10px + 5vh, 5px - 6%'
    offset: {
      type: [Number, String],
      default: 0,
    },
    delayShow: {
      // 延迟显示（单位：毫秒）
      type: Number,
      default: 0,
    },
    delayHide: {
      // @TODO 延迟隐藏（单位：毫秒）
      type: Number,
      default: 0,
    },
    closeOnClickOutside: {
      // 点击非 popper 或者 reference 以为的区域时是否隐藏（只有在 trigger === 'click' 的时候才生效）
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    arrow: {
      // 显示 arrow
      type: Boolean,
      default: true,
    },
    // popper 的宽度与 reference 一致
    widthEqualToReference: {
      type: Boolean,
      default: false,
    },
    boundariesElement: {
      type: [String, window.HTMLElement],
      default() {
        return 'viewport'
      },
    },
    blockPropagation: {
      type: Boolean,
      default: false,
    },
    // 当多个 reference 共用一个 popper 时，更换触发的 reference 时保持 popper 始终为 show（而不是 hide 后再 show
    keepShowOnReferenceChange: {
      type: Boolean,
      default: false,
    },
    beforeShow: {
      type: Function,
      default: null,
    },
    destroyOnHide: {
      type: Boolean,
      default: false,
    },
    // 当触发元素或其父元素固定定位时，建议使用positionFixed:true，防止tooltip随着页面滚动调整
    positionFixed: {
      type: Boolean,
      default: false,
    },
    // 空间的层级低于任何弹出层，以KNextBelowZIndex作为z-index累加基础
    below: {
      type: Boolean,
      default: false,
    },
    // popover 挂载的位置是否相对于body
    relativeToBody: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      popperId: KUuid(),
      opening: false, // 预计显示/隐藏
      showPopper: false, // 确定显示/隐藏
      reference: null,
      rendered: false, // 已经渲染过
      activated: true, // 组件是否激活，受 keep-alive 钩子函数影响
    }
  },
  computed: {
    basicOptions() {
      return _.assign({}, getMetaOptions(this.popperType))
    },
    popperClassObjectLike() {
      return convertPropClass2ClassObjectLike(this.popperClass)
    },
    nextZIndex() {
      if (this.below) {
        return KNextBelowZIndex
      }
      return KNextZIndex
    },
    finalShowPopper() {
      return this.showPopper && this.activated
    },
   },
  watch: {
    value: {
      handler(val) {
        if (val && this.beforeShow) {
          const result = this.beforeShow()
          this.$nextTick(() => {
            this.showPopper = this.opening = !!result
          })
        } else {
          this.showPopper = this.opening = val
        }
      },
    },
    opening() {
      this.checkPopperChain()
      if (this.blockPropagation && !this.opening) {
        this.hideSubPoppers()
      }
    },
    disabled(disabled) {
      if (disabled) {
        this.showPopper = false
      }
    },
    showPopper(value) {
      this.$emit('input', value)
      // this.showPopper ? this.updatePopper() : this.destroyPopper()
      // destroyPopper 的动作交给使用KPopper的组件去调用（通常在动效结束时）
      // this.showPopper && this.updatePopper()
      if (value) {
        if (!this.rendered) {
          this.rendered = true
        }
        this.updatePopper()
        // clearTimeout(this.scheduleHideTimer)
        // } else {
        // this.destroyPopper()
      } else {
        // clearTimeout(this.scheduleTimer)
      }
    },
    reference() {
      this.popperEngine && (this.popperEngine.reference = this.reference)
    },
    positionFixed() {
      this.createPopper()
    },
  },
  beforeCreate() {
    const parent = this.$parent

    this.popperVM = new Vue({
      name: 'KPopper',
      parent, // 关键，否则无法承接 $parent, inject 等特性
      data() {
        return {
          popperId: null,
          node: '',
        }
      },
      methods: {
        hide() {
          const sibling = _.find(this.$parent.$children, child => child.popperId === this.popperId && child !== this)
          if (sibling) {
            sibling.hide()
          }
        },
      },
      render() {
        return this.node
      },
    }).$mount()

    this.debounceHide = _.debounce(() => this.scheduleHide(), 100)
  },
  mounted() {
    this.$nextTick(() => {
      if (this.value) {
        this.show()
      }

      this.debounceHide = _.debounce(() => this.scheduleHide(), 100)
    })
  },
  beforeDestroy() {
    this.$emit('destroy')
    if (this.reference) {
      $(this.reference)
        .off(`mouseenter.${this.popperId}`)
        .off(`mouseleave.${this.popperId}`)
        .off(`click.${this.popperId}`)
        .off(`focus.${this.popperId}`)
        .off(`blur.${this.popperId}`)
    }

    if (this.popperEngine) {
      this.popperEngine.destroy()
      $(this.popperEngine.popper).remove()
    }

    unSub(CLICK_OUTSIDE, this.handleClickOutside)

    this.popperVM.$destroy()
  },
  methods: {
    bindTriggerEvents() {
      const $reference = $(this.reference)

      const triggerEvents = this.trigger.split(/\s+/)
      if (triggerEvents.indexOf('manual') > -1) {
        if (this.value) {
          this.showPopper = true
        }

        return
      }

      _.forEach(triggerEvents, (event) => {
        switch (event) {
          case 'hover':
            $reference
              .on(`mouseenter.${this.popperId}`, this.show) //
              .on(`mouseleave.${this.popperId}`, this.hide)
            break
          case 'click':
            $reference.on(`click.${this.popperId}`, this.toggle)
            this.onClickOutside()
            break
          case 'focus':
            const child = this.$children && this.$children.length && this.$children[0]
            if (child && isVueComponent(child)) {
              child.$on(`focus`, this.show)
              child.$on(`blur`, this.hide)
            }
            $reference.on(`focus.${this.popperId}`, this.show).on(`blur.${this.popperId}`, this.hide)
        }
      })
    },
    applyReactStyle(data) {
      this.popperData = data
    },
    createPopper() {
      const popper = (this.popper = this.popper || this.$refs.popper)
      let reference = (this.reference = this.reference || this.$refs.reference)

      if (!reference && this.$slots.reference && this.$slots.reference[0]) {
        reference = this.reference = this.$slots.reference[0].elm
      }

      if (!popper || !reference) {
        return
      }

      popper.style.zIndex = this.nextZIndex()

      if (this.relativeToBody) {
        $(popper).appendTo('body')
      } else {
        $(reference).parent().append(popper)
      }

      if (this.blockPropagation) {
        $(this.popper).on('click', e => {
          e.stopPropagation()
          this.hideSubPoppers()
        })
      }

      if (this.popperEngine && this.popperEngine.destroy) {
        this.popperEngine.destroy()
      }

      this.options = _.assignWith(
        this.basicOptions,
        {
          positionFixed: this.positionFixed,
          placement: this.placement,
          onCreate: (data) => {
            this.applyReactStyle(data)
          },
          onUpdate: (data) => {
            this.applyReactStyle(data)
          },
          modifiers: {
            preventOverflow: {
              enabled: true,
              escapeWithReference: false,
              boundariesElement: this.boundariesElement || 'viewport',
              //   //   boundariesElement: 'viewport',
            },
            computeStyle: {
              // 避免IE上translate3d导致视图模糊
              // gpuAcceleration: !KDevice.sys.ie,
              // 其他浏览器缩放也会导致视图模糊
              gpuAcceleration: false,
            },
            offset: {
              enabled: true,
              offset: this.offset,
              // fn: (data, options) => {
              //   console.log('modifiers offset: ', data, options)
              //   if (this.offset) {
              //
              //   }
              //   return data
              // },
            },
            // hide: {
            //   // order: 860,
            //   enabled: true,
            //   fn: (data) => {
            //     console.log(data.reference.)
            //     if (data.hide) {
            //       console.log('hide~~~~~~~~~')
            //     }
            //     return data
            //   },
            // },
            // adjustArrow: {
            //   order: 860,
            //   enabled: true,
            //   fn: (data) => {
            //     if (!this.arrow) {
            //       return data
            //     }
            //     const placement = data.placement
            //     const isArrowVertical = _.startsWith(placement, 'left') || _.startsWith(placement, 'right')
            //     const { width: refWidth, height: refHeight } = data.offsets.reference
            //     const { width: popWidth, height: popHeight } = data.offsets.popper
            //     // const { top: arrowTop, left: arrowLeft } = data.offsets.arrow
            //     const secondaryPlacement = data.placement.split('-')[1]
            //     if (isArrowVertical) {
            //       if (refHeight >= popHeight) {
            //         if (secondaryPlacement === 'start') {
            //           data.arrowStyles.top = Math.min(arrowSize, popHeight / 2 - arrowSize / 2 - arrowMargin)
            //         } else if (secondaryPlacement === 'end') {
            //           data.arrowStyles.top = popHeight - arrowSize * 2
            //         }
            //       }
            //     } else if (refWidth >= popWidth) {
            //       if (secondaryPlacement === 'start') {
            //         data.arrowStyles.left = Math.min(arrowSize, popWidth / 2 - arrowSize / 2 - arrowMargin)
            //       } else if (secondaryPlacement === 'end') {
            //         data.arrowStyles.left = popWidth - arrowSize * 2 - arrowMargin
            //       }
            //     }
            //
            //     return data
            //   },
            // },
            // assurePopperInWindow: {
            //   order: 860,
            //   enabled: true,
            //   fn: (data) => {
            // const placement = data.placement
            // const isVertical = _.startsWith(placement, 'top') || _.startsWith(placement, 'bottom')
            // const clientWidth = document.documentElement.clientWidth
            // const clientHeight = document.documentElement.clientHeight
            // const { top: refTop, bottom: refBottom, left: refLeft, right: refRight } = this.reference.getBoundingClientRect()
            // const { width: popperWidth, height: popperHeight } = this.popper.getBoundingClientRect()
            // // let { height: popperHeight } = this.popper.getBoundingClientRect()
            //
            // const result = {}
            //
            // if (isVertical) {
            //   const isTop = _.startsWith(placement, 'top')
            //   if (isTop) {
            //     if (refTop < popperHeight) {
            //       result.popperHeight = refTop
            //     }
            //   } else {
            //     if (clientHeight - refBottom < popperHeight) {
            //       result.popperHeight = clientHeight - refBottom
            //     }
            //   }
            // } else {
            //   const isLeft = _.startsWith(placement, 'left')
            //   if (isLeft) {
            //     if (refLeft < popperWidth) {
            //       result.popperWidth = refLeft
            //     }
            //   } else {
            //     if (clientWidth - refRight < popperWidth) {
            //       result.popperWidth = clientWidth - refRight
            //     }
            //   }
            // }
            //
            // if (result.popperHeight) {
            //   data.styles.height = result.popperHeight - 18 + 'px'
            // }
            //
            // if (result.popperWidth) {
            //   data.styles.width = result.popperWidth - 18 + 'px'
            // }
            //
            // return data
            // },
            // },
          },
        },
        (targetValue, sourceValue) => (_.isNil(sourceValue) ? targetValue : sourceValue),
      )

      this.popperEngine = new PopperEngine(reference, popper, this.options)
    },
    updatePopper() {
      const popperEngine = this.popperEngine
      if (popperEngine) {
        popperEngine.enableEventListeners()
        // popperEngine.update()
        popperEngine.scheduleUpdate()
        setTimeout(() => {
          popperEngine.scheduleUpdate()
        }, 500)
        if (popperEngine.popper) {
          const zIndex = this.nextZIndex()
          popperEngine.popper.style.zIndex = zIndex // nextZIndex()
        }
      } else {
        this.createPopper()
      }
    },
    destroyPopper() {
      const popperEngine = this.popperEngine
      if (popperEngine) {
        popperEngine.disableEventListeners()
      }

      if (this.destroyOnHide) {
        if (this.popperEngine) {
          this.popperEngine.destroy()
          $(this.popperEngine.popper).remove()
        }
        this.rendered = false
        this.popperEngine = null
      }
    },
    show() {
      if (this.disabled) {
        return
      }

      if (this.triggerReference && this.reference !== this.triggerReference) {
        // 复用 popper
        this.triggerReference = this.reference
        if (this.keepShowOnReferenceChange) {
          clearTimeout(this.scheduleHideTimer)
          this.opening = true
          this.showPopper = true
          this.updatePopper()
        } else {
          this.opening = false
          this.showPopper = false
          this.$nextTick(() => {
            this.show()
          })
        }
      } else {
        this.triggerReference = this.reference
        this.opening = true
        this.scheduleShow()
      }
    },
    hide() {
      this.opening = false
      this.debounceHide()
    },
    toggle() {
      if (this.disabled) {
        return
      }
      if (this.opening && (!this.triggerReference || this.reference !== this.triggerReference)) {
        this.triggerReference = this.reference
        this.opening = false
        this.showPopper = false
      }

      if (this.opening) {
        this.hide()
      } else {
        this.show()
      }
    },
    scheduleShow() {
      if (!this.opening || this.trigger === 'manual') {
        return
      }

      clearTimeout(this.scheduleTimer)
      this.scheduleTimer = setTimeout(() => {
        // this.showPopper = true
        this.showPopper = this.delayShow ? this.opening : true
      }, this.delayShow)
    },
    scheduleHide() {
      if (this.opening || this.trigger === 'manual') {
        return
      }

      clearTimeout(this.scheduleHideTimer)
      this.scheduleHideTimer = setTimeout(() => {
        // this.showPopper = false
        this.showPopper = this.delayHide || this.keepShowOnReferenceChange ? this.opening : false
      }, this.delayHide)
    },
    hideSubPoppers() {
      const poppers = getAllDescendantComponentsByName(this.popperVM, 'KPopper')
      _.forEach(poppers, popper => {
        // console.log('popper: ', popper, popper.hide())
        popper.hide()
      })
    },
    checkPopperChain() {
      if (this.trigger !== 'hover' && !this.opening) {
        return
      }

      const popper = getParentByName(this, 'KPopper')
      if (popper) {
        const { popperId } = popper
        const sibling = _.find(popper.$parent.$children, child => child.popperId === popperId && child !== popper)
        if (sibling) {
          this.$nextTick(() => {
            if (this.opening || this.blockPropagation) {
              sibling.opening = true
            } else {
              sibling.hide()
            }
          })
        }
      }
    },
    handleClickOutside(target) {
      if (
        this.opening &&
        this.reference &&
        this.popper &&
        !this.reference.contains(target) &&
        !this.popper.contains(target)
      ) {
        this.hide()
      } else {
        this.checkPopperChain()
      }
    },
    onClickOutside() {
      // if (!onClickOutsideRegistered) {
      //   onClickOutsideRegistered = true
      // sub(CLICK_OUTSIDE, (target) => {
      // clickTarget = target
      // })
      // }
      // sub(CLICK_OUTSIDE, (target) => {
      //   this.handleClickOutside(target)
      // })
      sub(CLICK_OUTSIDE, this.handleClickOutside)
    },
  },
  activated() {
    this.activated = true
  },
  deactivated() {
    this.activated = false
  },
}
